import html2canvas from 'html2canvas'
import { IGNORE_ON_ALL_EXPORT } from 'components_new/organisms/dialogs/ExportDialog'

/**
 * Returns an object with all the strings that where in all of
 * the lists.
 *
 * @param lists A list of lists with string
 * @returns An object containing the strings that where in all of the lists.
 */
export function itemsIncludedInAllLists(lists: string[][]) {
  const memo: { [item: string]: number } = {}
  const nrOfLists = lists.length

  lists.forEach((list) => {
    list.forEach((item) => {
      if (item in memo) {
        memo[item] += 1
      } else {
        memo[item] = 1
      }
    })
  })

  const returnObj: { [item: string]: string } = {}

  Object.keys(memo).forEach((item) => {
    if (memo[item] === nrOfLists) {
      returnObj[item] = item
    }
  })

  return returnObj
}

export async function downloadPNG(
  element: HTMLElement,
  callback: (img: Blob | null) => void
) {
  const canvas = await html2canvas(element, {
    allowTaint: true,
    useCORS: true,
    logging: false,
    ignoreElements: (element) => {
      return element.id === IGNORE_ON_ALL_EXPORT
    }
  })

  canvas.toBlob(callback)
}
